import globalStore from '$$store/main';
import _ from 'lodash';

const isDeepEmpty = function (obj) {
  return _.every(obj, prop => {
    if (!prop || _.isNull(prop) || prop === '' || prop.length === 0) {
      return true;
    } if (_.isDate(prop)) {
      return false;
    } if (_.isObject(prop)) {
      return isDeepEmpty(prop);
    }

    return false;
  });
};

export function getMyTasksFilterStatus(filterState) {
  if (!filterState || !filterState.assignee || !filterState.status) return false;
  if (filterState.assignee.length !== 1 || filterState.status.length !== 2) return false;

  const statuses = filterState.status ? filterState.status.join() : '';
  const resourceData = globalStore.getters['resourcesModel/getResourceByUserId'](user.id);

  if (resourceData.id === filterState.assignee[0] && (statuses === '1,2' || statuses === '2,1')) {
    if (isDeepEmpty(_.omit(filterState, ['assignee', 'status']))) return true;
  }

  return false;
}
